export default __webpack_public_path__ + "static/media/people-icon.6819f4fa.svg";